import { render, staticRenderFns } from "./ManageRicUser.vue?vue&type=template&id=824983c0"
import script from "./ManageRicUser.vue?vue&type=script&lang=ts"
export * from "./ManageRicUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports